import { render } from "./TopLayout.vue?vue&type=template&id=5b423876"
import script from "./TopLayout.vue?vue&type=script&lang=js"
export * from "./TopLayout.vue?vue&type=script&lang=js"

import "./TopLayout.vue?vue&type=style&index=0&id=5b423876&lang=css"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/pinenativeWeb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__